import React from "react";
import classNames from "classnames";

import {ExpandIcon, TrashIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Placeholder} from "@pg-design/image-module";

import {iconsWrap, imageStyle, imageWrap, pointer} from "./ImageFieldPreview.module.css";

export interface IImagePreviewProps {
    width: string;
    height: string;
    alt: string;
    imgSrc: string | undefined;
    className?: string;
    aspectRatio?: number;
    imageHolderClassName?: string;
    imageClassName?: string;
    /*
        Provide below callbacks to enable icons for each functionality
     */
    removeImage?: () => void | null;
    cropImage?: (previewImage: string) => void;
}

export function ImageFieldPreview(props: IImagePreviewProps) {
    const {width, height, aspectRatio, alt, imgSrc, className, removeImage, cropImage, imageClassName, imageHolderClassName} = props;

    return (
        <div style={{aspectRatio}} className={classNames(imageWrap, className)}>
            {imgSrc ? (
                <Image
                    alt={alt}
                    width={width}
                    height={height}
                    src={imgSrc}
                    className={imageHolderClassName}
                    imageClassName={classNames(imageStyle, imageClassName)}
                />
            ) : (
                <Placeholder />
            )}
            <div className={iconsWrap}>
                {cropImage && imgSrc && (
                    <ExpandIcon
                        onClick={() => {
                            cropImage(imgSrc);
                        }}
                        className={pointer}
                        size="2.5"
                        wrapperSize="4.4"
                        wrapperColor="#fff"
                    />
                )}
                {removeImage && <TrashIcon onClick={removeImage} className={pointer} size="3.2" wrapperSize="4.4" wrapperColor="#fff" />}
            </div>
        </div>
    );
}
import React from "react";
import classNames from "classnames";

import {ExpandIcon, TrashIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Placeholder} from "@pg-design/image-module";

import {iconsWrap, imageStyle, imageWrap, pointer} from "./ImageFieldPreview.module.css";

export interface IImagePreviewProps {
    width: string;
    height: string;
    alt: string;
    imgSrc: string | undefined;
    className?: string;
    aspectRatio?: number;
    imageHolderClassName?: string;
    imageClassName?: string;
    /*
        Provide below callbacks to enable icons for each functionality
     */
    removeImage?: () => void | null;
    cropImage?: (previewImage: string) => void;
}

export function ImageFieldPreview(props: IImagePreviewProps) {
    const {width, height, aspectRatio, alt, imgSrc, className, removeImage, cropImage, imageClassName, imageHolderClassName} = props;

    return (
        <div style={{aspectRatio}} className={classNames(imageWrap, className)}>
            {imgSrc ? (
                <Image
                    alt={alt}
                    width={width}
                    height={height}
                    src={imgSrc}
                    className={imageHolderClassName}
                    imageClassName={classNames(imageStyle, imageClassName)}
                />
            ) : (
                <Placeholder />
            )}
            <div className={iconsWrap}>
                {cropImage && imgSrc && (
                    <ExpandIcon
                        onClick={() => {
                            cropImage(imgSrc);
                        }}
                        className={pointer}
                        size="2.5"
                        wrapperSize="4.4"
                        wrapperColor="#fff"
                    />
                )}
                {removeImage && <TrashIcon onClick={removeImage} className={pointer} size="3.2" wrapperSize="4.4" wrapperColor="#fff" />}
            </div>
        </div>
    );
}
